import { NgModule, ModuleWithProviders } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/shared/shared.module";

import {
    KriDetailComponent,
    KriDetailMainComponent,
    KriDataComponent,
    KriOverviewComponent,
    KriDataService,
} from ".";
import { KriDataUploadComponent } from "./kri-data-upload/kri-data-upload.component";
import { KriRiskComponent } from "./kri-risk/kri-risk.component";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        KriDetailMainComponent,
        KriDataComponent,
        KriOverviewComponent,
        KriDataUploadComponent,
        KriRiskComponent,
        KriDetailComponent,
    ],
})
export class KriModule {
    static forRoot(): ModuleWithProviders<KriModule> {
        return {
            ngModule: KriModule,
            providers: [KriDataService],
        };
    }
}
